Librarian.InfoWindow = new Class({
    Extends: Librarian.Window,

    options: {
        id: "InfoWindow",
        height: 75,
        width: 420,
        padding: {
            top: 20,
            right: 20,
            bottom: 20,
            left: 20
        },
    },

    initialize: function(options) {
        this.setOptions(options);

        if (!this.options.contentURL)
            this.options.contentURL = Librarian.path.getLayoutsPath() + "pages/event/info.html";

        this.parent(this.options);
    },

    onWindowLoaded: function () {
        this.parent();
        this.setupElements();

        var textAreaEl = this.getElement("eventContentLink");
        textAreaEl.set("value", this.options.content);

        var copyButtonEl = this.getElement("eventContentLinkCopyBtn");
        copyButtonEl.addOnClick(function () {
            navigator.clipboard.writeText(textAreaEl.value);
            copyButtonEl.addClass("copied");
            copyButtonEl.set("value", "✔");
            Librarian.Utils.notification("Copied to Clipboard");
            setTimeout(
                function () {
                    copyButtonEl.removeClass("copied");
                    copyButtonEl.set("value", "Copy");
                }, 3000);
        });
    },
});
